import React, { useEffect, useState } from "react";
import styles from "./ingresoDNI.module.css";
import {  useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DNIaction } from "../../store/actions.js";
import ReactGA from "react-ga";
import Swal from "sweetalert2";

import LogoPrincipal from "./assets/LogoPrincipalHome.png";
// import Paso1 from "./assets/Paso1.png";
// import Paso2 from "./assets/Paso2.png";
// import paso3 from "./assets/Paso3.png";

import LogoConcierto from "./assets/CoollogoConciertos.png";
import Gaseosas from "./assets/Gaseosas.png";
import LogoIsm from "./assets/LogoISM.png";
import GaseosasMobile from "./assets/GaseosasMobile.png";
import LogoISMMobile from "./assets/LogoISMMobile.png";
import axios from "axios";

const IngresoDNI2 = () => {
  const dispatch = useDispatch();
  const [dni, setDNI] = useState("");

  const navigate = useNavigate();

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setDNI(newValue);
  };

  const InfoName = async () => {
    try {
      const resp = await axios.put(
        "https://winged-rain-production.up.railway.app/existeElUsuario", 
   
        {
          DNI: dni,
        }
      );

  
        navigate("/Bienvenido");
      
      if (resp.data === "no existe") {
        Swal.fire(
          "¡UPPPSS!",
          "El DNI o Carnet de Extranjería que enviaste no está registrado o lo escribiste mal. <br> Por favor, intenta con otro número",
          "error"
        );
        return;
      }
    } catch (error) {
       navigate("/Bienvenido");
      console.log(error);
    }
  };

  // const envioDNI = () => {
  //   dispatch(DNIaction(dni));
  // };

  useEffect(() => {
    ReactGA.pageview("/dni");
    document.title =
      "Ingreso: Destapa y gana conciertos gratis por un año / Cool Fresh, una marca de ISM";

    // Actualizar la descripción de la página
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Ingresa tu DNI o Carnet de Extranjería para destapar y ganar conciertos gratis por un año con Cool Fresh, una marca de ISM"
      );
    }
  }, []);


  const redirect = async () => {
    try {
        navigate("/");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.Home}>
      {/* <Link to={"/prueba"}> */}
        <img
          alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
          src={LogoPrincipal}
          className={styles.LogoPrincipal}
          onClick={redirect}
          style={{zIndex:'200'}}
        ></img>
      {/* </Link> */}
 <div className={styles.lefDiv}>
      <input
        type="text"
        placeholder="INGRESA TU DNI O CARNET DE EXTRANJERÍA."
        className={styles.inputDNI}
        value={dni}
        onChange={handleInputChange}
        style={{zIndex:'100'}}
      ></input>

      <button onClick={() => InfoName()} className={styles.button}>
        VALIDAR
      </button>
      </div>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoConcierto}
        className={styles.LogoConcierto}
      ></img>

      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={Gaseosas}
        className={styles.Gaseosas}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={GaseosasMobile}
        className={styles.GaseosasMobile}
      ></img>

      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoIsm}
        className={styles.LogoIsm}
      ></img>
      <img
        alt="destapa_gana_conciertos_gratis_cool_fresh_ISM"
        src={LogoISMMobile}
        className={styles.LogoISMMobile}
      ></img>
    </div>
  );
};

export default IngresoDNI2;
